<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">修改密码</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>密码设置</span></div>
                <ul class="forminfo">
                    <li>
                        <label>旧密码<b>*</b></label>
                        <div class="vocation">
                            <input type="password" v-model="pwd" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style="margin-left: 20px;">请输入旧密码</i>
                    </li>
                    <li>
                        <label>新密码<b>*</b></label>
                        <div class="vocation">
                            <input type="password" v-model="pwd1" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style="margin-left: 20px;">新密码长度为6-12</i>
                    </li>
                    <li>
                        <label>确定密码<b>*</b></label>
                        <div class="vocation">
                        <input type="password" v-model="pwd2" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style="margin-left: 20px;">确定密码和新密码一致</i>
                    </li>
                    <li>
                        <label>&nbsp;</label><input class="sure" type="button" @click="updatepassword()" value="确定">
                    </li>
                </ul>
                
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                <span><img src="@/images/dp.png" alt="提醒" /></span>
                <b>注意</b>
                </div>
                <ul class="infolist">
                    <li>(重要：API接口用户 修改密码前必须要联络第二办公室技术进行同步，否则影响API使用; 如被强制修改后，您可马上再改回原密码, 就不影响使用)</li>
                    <li> 忘记密码，请到首页用忘记密码功能取回密码 </li> 
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import { delCookie } from '@/assets/js/cookie.js'

export default {
    data() {
        return {
            pwd: '',
            pwd1: '',
            pwd2: '',
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    methods: {
        updatepassword() {
            if(this.pwd == '')
            {
                this.$alert("请输入原密码")
                return false
            }
            else if(this.pwd.length < 3 && this.pwd.length > 12)
            {
                this.$alert("原密码长度在6-12位之间")
            }
            if(this.pwd1 == '')
            {
                this.$alert("请输入新密码")
                return false
            }
            else if(this.pwd1.length < 3 && this.pwd1.length > 12)
            {
                this.$alert("新密码长度在6-12位之间")
                return false
            }
            if(this.pwd2 == '')
            {
                this.$alert("确认新密码不能为空")
                return false
            }
            else if(this.pwd2.length < 3 && this.pwd2.length > 12)
            {
                this.$alert("确认新密码长度在6-12位之间")
                return false
            }
            else if(this.pwd1 != this.pwd2)
            {
                this.$alert("两次输入新密码不一致")
                return false
            }
            var that = this
            let param = {'pwd': this.pwd, 'pwd1': this.pwd1, 'pwd2': this.pwd2}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/updatepassword.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert("修改成功,请重新登录!",{
                        confirmButtonText: '确定'
                    }).then(() =>{
                        delCookie('2officesessionid')
                        that.$router.push('/');
                    })
                    // that.$confirm('修改成功,请重新登录!', '提示', {
                    //     confirmButtonText: '重新登录',
                    //     cancelButtonText: '返回首页',
                    //     type: 'warning'
                    // }).then(() => {
                    //     delCookie('2officesessionid');
                    //     that.$router.push('/');
                    // }).catch(() => {
                    //     delCookie('2officesessionid');
                    //     that.$router.push('/');
                    // });
                    // delCookie('2officesessionid')
                    // alert("修改成功,请重新登录!");
                    // that.$router.push('/');
                }
                else
                {
                    // that.$alert(res.data.msg)
                    that.$message({
                        duration: 0,
                        showClose: true,
                        type: 'warning',
                        message: res.data.msg
                    })
                    return false
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/passwordset.vue